import router from '@/router';
// initial state
const initialState = () => {
    return {
        errors: [],
        message: null
    };
};
const state = initialState();

const getters = {
    getErrors: state => state.errors,
    getMessage: state => state.message
};

const mutations = {
    setErrors: (state, errors) => {
        state.errors = errors;
    },
    setMessage: (state, message) => {
        state.message = message
    },
    clear: (state) => {
        state.errors = [];
        state.message = null;
    }
};

const actions = {
    clear: ({commit}) => {
        commit('errors/clear', null, {root: true})
    },
    // error response
    errorResponse: (context, errorResponse) => {
        if (errorResponse && errorResponse.status) {
            window.e = errorResponse;
            let errorStatusCode = errorResponse.status;
            let errorData = [];
            switch (errorStatusCode) {
                case 422:
                    if (errorResponse.data.errors) {
                        Object.keys(errorResponse.data.errors).forEach(key => {
                            errorData[key] = errorResponse.data.errors[key][0];
                        });
                    }
                    break;
                case 401:
                    context.commit('auth/resetAuthData', null, {root: true});
                    router.push({name: 'home'});
                    break;
                case 403:
                    errorData['error'] = errorResponse.data.message;
                    break;
                case 500:
                    errorData['error'] = errorResponse.data.data.error;
                    break;
                default:
                    if (errorResponse.data.message) {
                        // console.log(errorResponse.data.message);
                        errorData['error'] = errorResponse.data.message;
                    } else if (errorResponse.data.data.error) {
                        errorData['error'] = errorResponse.data.data.error;
                    } else {
                        errorData['error'] = errorResponse.data.error;
                    }
                    break;
            }
            context.commit('errors/setErrors', errorData, {root: true});
        }
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
